import { render } from "./selectBtn.vue?vue&type=template&id=af87d904&scoped=true"
import script from "./selectBtn.vue?vue&type=script&lang=js"
export * from "./selectBtn.vue?vue&type=script&lang=js"

import "./selectBtn.vue?vue&type=style&index=0&id=af87d904&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af87d904"]])

export default __exports__